"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = require("../../theme/index");
const useVendorBillStyle = () => {
    const text = {
        display: 'flex',
        alignItems: 'center',
    };
    const item = {
        padding: '8px 0',
        svg: {
            width: '15px',
            marginRight: '10px',
        },
    };
    const greenText = {
        color: index_1.theme.palette.success.main,
    };
    return {
        text,
        item,
        greenText,
    };
};
exports.default = useVendorBillStyle;
